import type { ChangelogRelease } from '@/types/help/help.interface';

/* Deliberat separat de manual.ts: SideNav are nevoie doar de versiunea curenta
   pentru badge-ul "NEW", iar SideNav e pe TOATE paginile aplicatiei. Daca ar
   importa manualul, cele ~117 KB de markdown si biblioteca de randare ar intra
   in bundle-ul principal, incarcat si de cei care nu deschid niciodata Help. */
const RELEASES = import.meta.globEager('../../content/help/changelog/*.json') as Record<
    string,
    { default: ChangelogRelease } | ChangelogRelease
>;

const SEEN_KEY = 'helpSeenVersion';

function unwrap(entry: { default: ChangelogRelease } | ChangelogRelease): ChangelogRelease {
    return 'default' in entry ? entry.default : entry;
}

/** Release-urile, cel mai nou primul. */
export function loadChangelog(): Array<ChangelogRelease> {
    return Object.values(RELEASES)
        .map(unwrap)
        .sort((a, b) => b.date.localeCompare(a.date));
}

export function latestVersion(): string {
    return loadChangelog()[0]?.version ?? '';
}

/** true cat timp utilizatorul n-a deschis changelog-ul de la ultimul release. */
export function hasUnseenRelease(): boolean {
    const version = latestVersion();
    return version !== '' && localStorage.getItem(SEEN_KEY) !== version;
}

export function markChangelogSeen(): void {
    localStorage.setItem(SEEN_KEY, latestVersion());
}
